import './GeneralCardImageCards.css';
import React from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { isNil } from '../../utils/IsNil';
import { DefaultCards } from './components/DefaultCards';
import { CardListCards } from './components/CardListCards';
import { NOSCards } from './components/NOSCards';
export let EGeneralCardsImageTypes = /*#__PURE__*/function (EGeneralCardsImageTypes) {
  EGeneralCardsImageTypes["Default"] = "Default";
  EGeneralCardsImageTypes["CardsList"] = "CardsList";
  EGeneralCardsImageTypes["NOS"] = "NOS";
  return EGeneralCardsImageTypes;
}({});
export const GeneralCardImageCards = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (!fields) {
    console.info('GeneralCardImageCards component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [GeneralCardImageCards component is empty: please provide data source]");
    }
    return null;
  }
  const cardVariant = get(params, 'variant');
  const isDetSite = get(params, 'RenderingStyle') === 'DDA' || false;
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex', getColorByTheme(BackgroundColorHex));
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const variables = BackgroundColorHex ? {
    '--general-card-image-cards-color': BackgroundColorHex,
    '--general-card-image-cards-background-active-color': ActiveColorHex,
    '--general-card-image-cards-text-color': ColorHex
  } : {
    '--general-card-image-cards-color': selectedPrimaryColor,
    '--general-card-image-cards-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--general-card-image-cards-text-color': getColorByTheme(selectedPrimaryColor)
  };
  const generalCardsImageMap = {
    Default: /*#__PURE__*/React.createElement(DefaultCards, {
      fields: fields,
      params: params
    }),
    CardsList: /*#__PURE__*/React.createElement(CardListCards, {
      fields: fields,
      params: params
    }),
    NOS: /*#__PURE__*/React.createElement(NOSCards, {
      fields: fields,
      params: params
    })
  };
  if (isNil(generalCardsImageMap[cardVariant])) {
    console.warn(`component with "${cardVariant}" variant is not defined, try to use of this options ${Object.values(EGeneralCardsImageTypes)}`);
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    isDetSite: isDetSite,
    rtl: rtl,
    style: variables,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, generalCardsImageMap[cardVariant]);
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    className,
    anchorUrlParameter,
    style,
    isDetSite
  } = _ref2;
  const commonStyles = isDetSite ? "caly01w" : "c16juys0";
  const ltrStyles = isDetSite ? "lz3b8e6" : "l1c9n8yk";
  const rtlStyles = isDetSite ? "r1cmnjtl" : "rovlr9y";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    style: style,
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, children);
};
export default GeneralCardImageCards;